import Alpine from "alpinejs";
import GLightbox from "glightbox";

// Initialize GLightbox
const lightbox = GLightbox({
    selector: ".glightbox",
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    zoomable: false,
    draggable: false,
});

// Make GLightbox available globally
window.GLightbox = GLightbox;

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import "./alpine/index";
